import * as React from 'react';
import { UIBasic, IPropsBasic } from 'kts-scaffold-framework/modules';
import { connect } from 'kts-platform-frame/redux';
import ReduxState, { } from 'kts-platform-frame/redux/ReduxState';
import ModulesState from './Modules.State';
import ModulesAction from './Modules.Action';
import { withRouter } from 'kts-platform-frame/routes';
import { Field } from 'kts-scaffold-framework/utils/doc';
import { Row, Col } from 'antd';

const css = require('./index.scss');

/** Redux接口 */
interface IReduxStatePart {
    
}

/** Props接口 */
interface IProps extends IReduxStatePart, IPropsBasic {

}

/** 绑定全局数据到props */
@withRouter
@ModulesAction.uiconnect
@connect((state: ReduxState): IReduxStatePart => ({

}))
export default class UIComponents extends UIBasic<IProps, ModulesState> {

    constructor(props: IProps) {
        super(props, ModulesAction);
    }
    
    render() {
        const documentInfo = this.modulesState.receiptAdviceForm;
        return (
            <div className={css.baseInfo}>
                <Row style={{ lineHeight: '34px' }}>
                    <Col span={12}>
                        <Row>
                            <Col span={5}>
                                <span className={css.titleName}>收货方</span>
                            </Col>
                            <Col span={17}>
                                <span className={css.info}>{documentInfo.DeliveryCustomerParty.Name}</span>
                                {/* &nbsp;&nbsp;<a href="#">查看资料</a> */}
                            </Col>
                        </Row>
                        <Row>
                            <Col span={5}>
                                <span className={css.titleName}>收货联系人</span>
                            </Col>
                            <Col span={17}>
                                <span className={css.info}>{documentInfo.DeliveryCustomerContact.Name}</span>
                            </Col>
                        </Row>
                        <Row>
                            <Col span={5}>
                                <span className={css.titleName}>发货方</span>
                            </Col>
                            <Col span={17}>
                                <span className={css.info}>{documentInfo.DespatchSupplierParty.Name}</span>
                                {/* &nbsp;&nbsp;<a href="#">查看资料</a> */}
                            </Col>
                        </Row>
                        <Row>
                            <Col span={5}>
                                <span className={css.titleName}>发货联系人</span>
                            </Col>
                            <Col span={17}>
                                <span className={css.info}>{documentInfo.DespatchSupplierContact.Name}</span>
                            </Col>
                        </Row>
                        <Row>
                        {
                            documentInfo.RejectReason &&
                            <div>
                                <Col span={5}>
                                    <span className={css.titleName}>拒绝理由</span>
                                </Col>
                                <Col span={17}>
                                    <div className={`${css.info} ${css.wordWrapBreak}`}>{documentInfo.RejectReason}</div>
                                </Col>
                            </div>
                        }
                        </Row>
                    </Col>
                    <Col span={10} offset={2}>
                        <Row>
                            <Col span={5}>
                                <span className={css.titleName}>编号</span>
                            </Col>
                            <Col span={17}>
                                <span className={css.info}>{documentInfo.ID}</span>
                            </Col>
                        </Row>
                        <Row>
                            <Col span={5}>
                                <span className={css.titleName}>填报时间</span>
                            </Col>
                            <Col span={17}>
                                <span className={css.info}>{documentInfo.IssueDate && Field.formatTime(documentInfo.IssueDate)}</span>
                            </Col>
                        </Row>
                        {/* <Row>
                            <Col span={5}>
                                <span className={css.titleName}>过账日期</span>
                            </Col>
                            <Col span={17}>
                                <span className={css.info}>{documentInfo.PostingDate && Field.formatDate(documentInfo.PostingDate)}</span>
                            </Col>
                        </Row> */}
                    </Col>
                </Row>
            </div>
        );
    }
}


// WEBPACK FOOTER //
// ./src/display/platform/Document/DocumentDetail/UI.ReceiptAdviceBaseInfo.tsx